import React, {Fragment} from 'react';
import {useTranslation} from "@Translation/hooks/useTranslation";
import Column from "@Containers/components/Column";
import StationWithDateTimesType from "@SearchResults/types/station/StationWithDateTimes.type";
import getFormattedTravelTime from "@Route/functions/getFormattedTravelTime";

interface RouteBusChangeDetailsProps {
    stop: StationWithDateTimesType,
}

function RouteBusChangeDetails({stop}: RouteBusChangeDetailsProps) {
    const {arrival, departure} = useTranslation("sys")
    const {
        id,
        name,
        arrivalTime,
        departureTime,
    } = stop
    const label = `${arrival} - ${getFormattedTravelTime({travelTime: arrivalTime})} | 
                       ${departure} - ${getFormattedTravelTime({travelTime: departureTime})}`
    return (
        <Fragment key={id}>
            <Column>
                 <span className="gb--emphasize-default travel-stations__station-name">
                    {name}
                 </span>
                <small>
                    {label}
                </small>
            </Column>
        </Fragment>
    );
}

export default RouteBusChangeDetails;